export default {
  pageNavbar: [
    {
      name: "Stacja multimedialna",
      anchor: "sda"
    },
    {
      name: "Telefon",
      anchor: "phone"
    },
    {
      name: "System nagłośnienia",
      anchor: "mpss"
    },
    {
      name: "Informacje i Nawigacja",
      anchor: "informations"
    },
    {
      name: "Monitoring",
      anchor: "camera"
    },
    {
      name: "Inne",
      anchor: "features"
    }
  ],
  headerDesc:
    "Jedź dokąd chcesz i kiedy chcesz. Odkrywaj nowe miejsca i nową rozrywkę. Stacja multimedialna SDA (Smartphone Link Display Audio) Ci w tym pomoże. Duży 8-calowy ekran dotykowy umożliwia intuicyjną obsługę odtwarzacza muzycznego i telefonu, a polecenia głosowe zapewniają przyjemniejszą i bezpieczniejszą jazdę. Niezależnie od wersji wyposażenia stacja SDA wyposażona jest w funkcjonalny interfejs Android Auto/Apple Car Play.",
  headerButton: "Zobacz wideo",
  audioSubHeader: "System nagłośnienia",
  audioHeader: "Mitsubishi power sound system (MPSS) ze wzmacniaczem",
  audioDesc:
    "System dźwiękowy MPSS opracowany przez Mitsubishi Motors oferuje krystalicznie czystą, płynną i żywą akustykę, jakiej można oczekiwać po systemie dźwiękowym w samochodzie klasy premium. Sześć głośników, w tym cztery głośniki z włókna szklanego oraz aluminiowe głośniki stożkowe w drzwiach oraz dwa kopułkowe głośniki wysokotonowe z tytanu, otacza kabinę, aby wywołać spektakularne wrażenia dźwiękowe.",
  textWitVideoSubHeader: "Stacja multimedialna",
  textWitVideoHeader: "Informacje o napędzie phev",
  textWitVideoDesc:
    "Graficzne wskazania, między innymi monitor zużycia i przepływu energii pozwalający kierowcy w mgnieniu oka sprawdzić różne informacje dotyczące napędu PHEV. Na wyświetlaczu można również ustawić programator czasowy ładowania i zdalne sterowanie klimatyzacją.",
  textWitVideoHeaderSecond: "System nawigacji",
  textWitVideoDescSecond:
    "Wielofunkcyjna nawigacja zawiera mapy Polski i Europy. Wskazówki dotyczące podróży (w tym ograniczenia prędkości) wyświetlane są  w jasny i przejrzysty sposób na dużym ekranie, co czyni jazdę sprawniejszą i bezpieczniejszą.",
  textWitVideoButton: "Zobacz wideo",
  cameraSubHeader: "Monitoring",
  cameraHeader: "System kamer 360",
  cameraDesc:
    "Widok z kamer zamontowanych z przodu, z tyłu oraz z boków samochodu (w tym symulacja widoku z lotu ptaka) można wyświetlić w różnych kombinacjach w celu sprawdzenia, co kryje się w martwych polach i ułatwienia sobie bezpiecznego parkowania.",
  cameraButton: "Zobacz wideo",
  footerSlider: [
    {
      header: "8-CALOWY EKRAN DOTYKOWY",
      description:
        "Umieszczony wysoko dotykowy ekran systemu multimedialnego pozwala w łatwy sposób zarządzać wybranymi funkcjami samochodu. Ekran wyświetla również widok z kamery cofania oraz (w zależności od wersji wyposażenia) obraz z systemu kamer 360.",
      background: "RADIOODTWARZACZ.png"
    },
    {
      header: "Port USB",
      description:
        "Port komfortowo umieszczony obok deski rozdzielczej jest łatwo dostępny zarówno z fotela kierowcy, jak i pasażera.",
      background: "USB.png"
    },
    {
      header: "Wyświetlacz przezierny",
      description:
        "Pozwala szybko odczytać informacje i alerty dotyczące jazdy. Środowisko przypominające wysoce funkcjonalny kokpit lotniczy w naturalny sposób zwiększa zdolność koncentracji przy prowadzeniu samochodu",
      background: "headup.png"
    }
  ]
};
